import React, {useEffect, useMemo} from 'react';
import {useJobContext} from 'contexts/JobContext';
import {PartialJob} from 'shared/types/PartialJob';
import {Room} from 'components/customer/Confirmation/Checkout/Room';
import {useGetJobQuery} from 'components/customer/Job/store/jobApi';
import {Row} from 'components/customer/Confirmation/Checkout/Table';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {useAppContext} from 'contexts/ApplicationContext';
import {JOB_STATUS} from 'components/customer/Dashboard/LastJobButton';

export const Rooms = () => {
    const {userProfile} = useAppContext();
    const {job} = useJobContext() as PartialJob;
    const {
        data: updatedJob,
        refetch,
        isUninitialized,
    } = useGetJobQuery(
        {
            jobId: Number(job.id),
        },
        {
            skip: typeof job?.id === 'undefined',
        }
    );

    useEffect(() => {
        if (!isUninitialized) {
            void refetch();
        }
    }, []);

    const addRoomRoute = useMemo(() => {
        return `/v2/job/${job.displayId}/room`;
    }, [job]);

    if (updatedJob) {
        if (updatedJob.rooms && updatedJob.rooms.length > 0) {
            return updatedJob.rooms.map((room) => {
                return <Room room={room} key={room.id} />;
            });
        } else {
            if (
                userProfile.isAddProductAvailable &&
                job.status == JOB_STATUS.PROCESSING
            ) {
                return (
                    <Row>
                        <td colSpan={3}>
                            <NoRoomText>
                                No Room has been added to the current job. Click{' '}
                                <Link to={addRoomRoute}>
                                    here to add a room
                                </Link>
                            </NoRoomText>
                        </td>
                    </Row>
                );
            }
        }
    }
};

const NoRoomText = styled.div`
    font-weight: 400;
    font-size: 0.8em;
    color: #414141;
    display: block;
    text-align: center;

    > a {
        color: red;
    }
`;
